import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[dynamicComponent]',
    standalone: false
})
export class DynamicComponentDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}